import { financeNames } from '../../../modules/json/financeNames';

const getFinanceNameFromKey = function (vehicle, key, useShortName = false) {
    if (useShortName) {
        const shortName = getFinanceNameFromKey(vehicle, key + '.short', false);
        if (shortName !== 'Finance') {
            if (shortName == 'Hire Purchase') {
                return 'Conditional Sale';
            }
            if (shortName == 'HP') {
                return 'CS';
            }
            return shortName;
        }
    }
    if (typeof financeNames[vehicle.brand + '.' + key] !== 'undefined') {
        if (financeNames[vehicle.brand + '.' + key] == 'Hire Purchase') {
            return 'Conditional Sale';
        }
        return financeNames[vehicle.brand + '.' + key];
    }
    if (vehicle.brand == 'randd' || vehicle.brand == '' || vehicle.brand == 'RobinsAndDay' || vehicle.brand == false) {
        if (typeof financeNames[vehicle.manufacturer.toLowerCase() + '.' + key] !== 'undefined') {
            if (financeNames[vehicle.manufacturer.toLowerCase() + '.' + key] == 'Hire Purchase') {
                return 'Conditional Sale';
            }
            return financeNames[vehicle.manufacturer.toLowerCase() + '.' + key];
        }
    }
    if (typeof financeNames['.' + key] !== 'undefined') {
        if (financeNames['.' + key] == 'Hire Purchase') {
            return 'Conditional Sale';
        }
        return financeNames['.' + key];
    }
    return 'Finance';
}

export default getFinanceNameFromKey;


// WEBPACK FOOTER //
// ./resources/assets/js/new-vue/api/finance/GetFinanceNameFromKey.js